import {
  JsonapiEntity,
  attribute,
  entity,
  meta,
  relationship,
} from 'jsonapi-transformers';

import {
  BibliographicResource,
  OnlineResource,
} from '®shared/bibliographic-resource';
import { DigitisedContent } from '®shared/list-item/digitisation';
import { Importance, Tenant } from '®shared/tenant';

import { Citation } from './citation';
import { Container } from './container';
import { EditableItem } from './editable-item';
import { ReadingListDetails } from './reading-list-details';
import { Section } from './section';

@entity({ type: 'items' })
export class ListItem extends JsonapiEntity<ListItem> implements EditableItem {
  @relationship() container?: Container;
  @relationship() content?: DigitisedContent;
  @relationship() importance?: Importance;
  @relationship() list?: ReadingListDetails;
  @relationship() section?: Section;
  @relationship() tenant?: Tenant;
  @attribute() student_note?: string;
  @attribute() library_note?: string;
  @relationship() resource?: BibliographicResource;
  @meta() citation?: Citation;
  @meta({ name: 'default_online_resource' })
  defaultOnlineResource?: OnlineResource;
}
